import { createElement } from 'react';

const createSkeletonItem = (tag, className, type, condition, i=1, fadeOut=false) => (condition ? (
  createElement(
    tag,
    {
      className: `${className || ''} skeleton ${type && `skeleton--${type}`}${fadeOut ? ' skeleton--fadeOut' : ''}`,
      key: `${type}-${i}`
    },
    null,
  )
) : null);

const createSkeletonItems = (tag, className, type, count, condition, fadeOut=false) => (condition ? (
  Array.from({ length: count }, (_, i) => createSkeletonItem(tag, className, type, condition, i, fadeOut)
  )
) : null);

export { createSkeletonItem, createSkeletonItems };
